import type React from "react"

interface LoaderProps {
    size?: "small" | "medium" | "large"
    color?: "primary" | "secondary" | "accent"
}

const Loader: React.FC<LoaderProps> = ({ size = "medium", color = "primary" }) => {
    const sizeClasses = {
        small: "w-4 h-4",
        medium: "w-8 h-8",
        large: "w-12 h-12",
    }

    const colorClasses = {
        primary: "border-primary",
        secondary: "border-secondary",
        accent: "border-accent",
    }

    return (
        <div className="flex justify-center items-center">
            <div
                className={`
          ${sizeClasses[size]}
          ${colorClasses[color]}
          animate-spin
          rounded-full
          border-2
          border-t-transparent
        `}
            />
        </div>
    )
}

export default Loader

